// extracted by mini-css-extract-plugin
export default {"baseTextInfoColumn":"CreateEditOrganizationForm__baseTextInfoColumn-eEsi1","logoColumn":"CreateEditOrganizationForm__logoColumn-MaXiI"};